/** Section icons by name (src/content/help/sections.js). */
import PropTypes from 'prop-types';
import {
  Armchair, BedDouble, BookOpen, CalendarClock, Compass, LifeBuoy, Mail, MessageCircle,
  Plane, PlaneTakeoff, RefreshCcw, ShieldCheck, Sparkles, UserRound,
} from 'lucide-react';

const ICONS = {
  Armchair, BedDouble, CalendarClock, Compass, LifeBuoy, Mail, MessageCircle,
  Plane, PlaneTakeoff, RefreshCcw, ShieldCheck, Sparkles, UserRound,
};

export default function HelpIcon({ name, className = 'h-5 w-5' }) {
  const Icon = ICONS[name] || BookOpen;
  return <Icon className={className} strokeWidth={1.5} aria-hidden />;
}
HelpIcon.propTypes = { name: PropTypes.string, className: PropTypes.string };
